'use strict';

var _jsx = require('@babel/runtime/helpers/jsx');
var React = require('react');
require('prop-types');
var classnames = require('classnames');
function getAugmentedNamespace(n) {
  if (n.__esModule) return n;
  var f = n.default;
  if (typeof f == "function") {
    var a = function a() {
      if (this instanceof a) {
        return Reflect.construct(f, arguments, this.constructor);
      }
      return f.apply(this, arguments);
    };
    a.prototype = f.prototype;
  } else a = {};
  Object.defineProperty(a, '__esModule', {
    value: true
  });
  Object.keys(n).forEach(function (k) {
    var d = Object.getOwnPropertyDescriptor(n, k);
    Object.defineProperty(a, k, d.get ? d : {
      enumerable: true,
      get: function () {
        return n[k];
      }
    });
  });
  return a;
}
const RECOMMENDATIONS_HEART_EMPTY = 'recommendations-heart-empty';
const RECOMMENDATIONS_HEART_FULL = 'recommendations-heart-full';
const RECOMMENDATIONS_FULL_ICON = 'recommendations-full_icon';
const RECOMMENDATIONS_CHEVRON = 'recommendations-chevron';
const RECOMMENDATIONS_START_EMPTY = 'recommendations-star-empty';
const RECOMMENDATIONS_START_HALF = 'recommendations-star-half';
const RECOMMENDATIONS_START_FULL = 'recommendations-star-full';
const RECOMMENDATIONS_MELI_LOGO = 'recommendations-meli_logo';
const RECOMMENDATIONS_MELI_COINS = 'recommendations-meli_coins';
const RECOMMENDATIONS_CPG_ICON = 'recommendations-cpg_icon';
const RECOMMENDATIONS_CBT_ICON = 'recommendations-cbt_icon';
const RECOMMENDATIONS_BLACK_FRIDAY_ICON = 'recommendations-black-friday_icon';
const RECOMMENDATIONS_MELICHOICE_LOGO = 'recommendations-melichoice_logo';
const RECOMMENDATIONS_BUFLO_ICON_INFO = 'recommendations-buflo_icon_info';
const RECOMMENDATIONS_MSHOPS_LOGO = 'recommendations-mshops_logo';
const RECOMMENDATIONS_CLOCK_ICON = 'recommendations-clock_icon';
const RECOMMENDATIONS_STORE_ICON = 'recommendations-store_icon';
const RECOMMENDATIONS_FIRE_ICON = 'recommendations-fire_icon';
const RECOMMENDATIONS_BADGE_ICON = 'recommendations-badge_icon';
const RECOMMENDATIONS_INFO_ICON = 'recommendations-info_icon';
const RECOMMENDATIONS_APPAREL_ICON = 'recommendations-clothing_icon';
const RECOMMENDATIONS_BEAUTY_ICON = 'recommendations-beauty_icon';
const RECOMMENDATIONS_TOOLS_ICON = 'recommendations-tools_icon';
const RECOMMENDATIONS_SUPERMARKET_ICON = 'recommendations-super_icon';
const RECOMMENDATIONS_DECO_ICON = 'recommendations-furniture_icon';
var icons = /*#__PURE__*/Object.freeze({
  __proto__: null,
  RECOMMENDATIONS_APPAREL_ICON: RECOMMENDATIONS_APPAREL_ICON,
  RECOMMENDATIONS_BADGE_ICON: RECOMMENDATIONS_BADGE_ICON,
  RECOMMENDATIONS_BEAUTY_ICON: RECOMMENDATIONS_BEAUTY_ICON,
  RECOMMENDATIONS_BLACK_FRIDAY_ICON: RECOMMENDATIONS_BLACK_FRIDAY_ICON,
  RECOMMENDATIONS_BUFLO_ICON_INFO: RECOMMENDATIONS_BUFLO_ICON_INFO,
  RECOMMENDATIONS_CBT_ICON: RECOMMENDATIONS_CBT_ICON,
  RECOMMENDATIONS_CHEVRON: RECOMMENDATIONS_CHEVRON,
  RECOMMENDATIONS_CLOCK_ICON: RECOMMENDATIONS_CLOCK_ICON,
  RECOMMENDATIONS_CPG_ICON: RECOMMENDATIONS_CPG_ICON,
  RECOMMENDATIONS_DECO_ICON: RECOMMENDATIONS_DECO_ICON,
  RECOMMENDATIONS_FIRE_ICON: RECOMMENDATIONS_FIRE_ICON,
  RECOMMENDATIONS_FULL_ICON: RECOMMENDATIONS_FULL_ICON,
  RECOMMENDATIONS_HEART_EMPTY: RECOMMENDATIONS_HEART_EMPTY,
  RECOMMENDATIONS_HEART_FULL: RECOMMENDATIONS_HEART_FULL,
  RECOMMENDATIONS_INFO_ICON: RECOMMENDATIONS_INFO_ICON,
  RECOMMENDATIONS_MELICHOICE_LOGO: RECOMMENDATIONS_MELICHOICE_LOGO,
  RECOMMENDATIONS_MELI_COINS: RECOMMENDATIONS_MELI_COINS,
  RECOMMENDATIONS_MELI_LOGO: RECOMMENDATIONS_MELI_LOGO,
  RECOMMENDATIONS_MSHOPS_LOGO: RECOMMENDATIONS_MSHOPS_LOGO,
  RECOMMENDATIONS_START_EMPTY: RECOMMENDATIONS_START_EMPTY,
  RECOMMENDATIONS_START_FULL: RECOMMENDATIONS_START_FULL,
  RECOMMENDATIONS_START_HALF: RECOMMENDATIONS_START_HALF,
  RECOMMENDATIONS_STORE_ICON: RECOMMENDATIONS_STORE_ICON,
  RECOMMENDATIONS_SUPERMARKET_ICON: RECOMMENDATIONS_SUPERMARKET_ICON,
  RECOMMENDATIONS_TOOLS_ICON: RECOMMENDATIONS_TOOLS_ICON
});
var require$$0 = /*@__PURE__*/getAugmentedNamespace(icons);
var constants = require$$0;
var _path;
const namespace = 'ui-recommendations-icon';

/* eslint-disable max-len */
const InfoIcon = _ref => {
  let {
    className = null
  } = _ref;
  return /*#__PURE__*/_jsx("svg", {
    className: classnames(namespace, className),
    width: "12",
    height: "15",
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, void 0, _path || (_path = /*#__PURE__*/_jsx("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.001 7C12.001 10.3137 9.31469 13 6.00098 13C2.68727 13 0.000976562 10.3137 0.000976562 7C0.000976562 3.68629 2.68727 1 6.00098 1C9.31469 1 12.001 3.68629 12.001 7ZM7.84317 9.41893V10.1881H4.41387V9.41893H5.54351V6.55892H4.68941V5.7897H6.6653V9.41893H7.84317ZM6.67779 4.37014C6.67779 4.73567 6.38147 5.03199 6.01594 5.03199C5.65041 5.03199 5.35409 4.73567 5.35409 4.37014C5.35409 4.0046 5.65041 3.70828 6.01594 3.70828C6.38147 3.70828 6.67779 4.0046 6.67779 4.37014ZM0.924046 7C0.924046 9.80391 3.19707 12.0769 6.00098 12.0769C8.80489 12.0769 11.0779 9.80391 11.0779 7C11.0779 4.19609 8.80489 1.92307 6.00098 1.92307C3.19707 1.92307 0.924046 4.19609 0.924046 7Z",
    fill: "black",
    fillOpacity: "0.55"
  })));
};
const ClockIconMemo = /*#__PURE__*/React.memo(InfoIcon);
ClockIconMemo.ICON_ID = constants.RECOMMENDATIONS_INFO_ICON;
var ClockIconMemo$1 = ClockIconMemo;
module.exports = ClockIconMemo$1;
